import React, {useEffect, useState} from 'react';
import {loadArea, loadBlacklistHistory} from "../httpUtils";
import {
    TableCell
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";

export default function LicencePlateBlacklistHistory(props) {
    const [number, setNumber] = useState();
    const [blacklistHistoryList, setBlacklistHistoryList] = useState([]);
    const [areaList, setAreaList] = useState([]);

    useEffect(()=>{
        setNumber(props.number);
    }, [props.number])

    function load(){
        loadBlacklistHistory(number).then((r)=>{
            setBlacklistHistoryList(r);
            loadArea().then((r)=>{
                setAreaList([{id: 0, name: "Улица"},...r]);
            }).catch((e)=>{

            })
        }).catch((e)=>{

        })
    }

    useEffect(()=>{
        if (number){
            load()
        }
    }, [number])

    useEffect(()=>{
        if (props.onReload) load()
    }, [props.onReload])

    useEffect(()=>{
        props.hasOwnProperty('isEmpty') && props.isEmpty(blacklistHistoryList.length === 0);
    }, [blacklistHistoryList])

    return(
        <React.Fragment>
            <TableContainer>
                <Table aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <TableCell><Typography>Заблокирован</Typography></TableCell>
                            <TableCell><Typography>Разблокирован</Typography></TableCell>
                            <TableCell><Typography>Причина</Typography></TableCell>
                            <TableCell><Typography>Запрещенные территории</Typography></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {blacklistHistoryList.map((row, i) => (
                            <TableRow key={`tblre-${i}`}>
                                <TableCell align="left"><Typography>{ new Date(row.begin).toLocaleString()}</Typography></TableCell>
                                <TableCell align="left"><Typography>{row.end ? new Date(row.end).toLocaleString() : "-"}</Typography></TableCell>
                                <TableCell>
                                    <Typography>{row.disallowReason}</Typography>
                                </TableCell>
                                <TableCell>
                                    {row.disallowAreas.map((da)=>(
                                        <Typography key={`${i}-${da}-da`}>{areaList.find((a)=>a.id === da)?.name}</Typography>
                                    ))}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </React.Fragment>
    )
}